export const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const isValidEmail = (email) => emailRegex.test(email);
export const validateEmailWithMessage = (email) => {
  if (!email || typeof email !== "string") {
    return { valid: false, message: "Email is required." };
  }

  const trimmedEmail = email.trim();

  if (trimmedEmail === "") {
    return { valid: false, message: "Email cannot be empty." };
  }

  // Basic format check
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!emailRegex.test(trimmedEmail)) {
    return { valid: false, message: "Invalid email format." };
  }

  return { valid: true, message: "Valid email." };
};
